import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'
import { OptionUsage } from '@ulysses-inc/harami_api_client'
import { OptionUsageRow } from './OptionUsageRow'

type OptionUsagesTableProps = {
  optionUsages: OptionUsage[]
}

export const OptionUsagesTable = ({ optionUsages }: OptionUsagesTableProps) => {
  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell>
            <Typography variant="body1" fontWeight="bold">
              日付
            </Typography>
          </TableCell>
          <TableCell>
            <Typography variant="body1" fontWeight="bold">
              使用量
            </Typography>
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {optionUsages.map(ou => (
          <OptionUsageRow key={ou.optionKey + ou.period} optionUsage={ou} />
        ))}
      </TableBody>
    </Table>
  )
}
